<template>
  <div class="w-full border border-truegray-300">
    <div
      class="px-6 py-3 items-center flex flex-wrap cursor-pointer"
      @click="toggleFocus"
    >
      <svg
        :class="isFocused ? 'rotate-90' : ''"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-8 transform transition-all duration-300"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
      <h5 class="font-primary mb-0">{{ label }}</h5>
      <div
        v-if="filtersCount"
        :class="isCloud ? 'bg-cw-alt' : 'bg-primary'"
        :style="[{ fontSize: '0.5rem' }]"
        class="ml-2 rounded-full text-white font-bold h-4 w-4 flex items-center justify-center"
      >
        {{ filtersCount }}
      </div>
    </div>

    <div
      :class="
        isFocused
          ? 'h-auto transition-all duration-300 ease-in-out'
          : 'h-0 opacity-0 pointer-events-none'
      "
    >
      <div
        ref="dropdownSelect"
        :class="flex ? 'flex flex-wrap' : ''"
        data-list="selectList"
      >
        <div
          v-for="(option, i) in options"
          :id="'listbox-' + i"
          :key="i"
          role="option"
        >
          <div
            class="flex-shrink-0 cursor-pointer relative flex items-center px-4 h-12 mr-4 last:mr-0"
            @click="triggerSelected(option)"
          >
            <div class="flex space-x-2 items-center justify-start">
              <div
                class="h-3 w-3 rounded border"
                :class="{
                  'rounded-full': !multiselect,
                  'border-truegray-300': !selectedOptions.includes(
                    option.value,
                  ),
                  'bg-primary border-primary':
                    selectedOptions.includes(option.value) && !isCloud,
                  'bg-cw-alt border-cw-alt':
                    selectedOptions.includes(option.value) && isCloud,
                }"
              />
              <span class="block truncate text-truegray-500 text-left">{{
                option.text
              }}</span>
              <!--
                <svg v-if="multiselect && selectedOptions.includes(option.value)" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg> 
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { EventBus } from '../../js/plugins/event-bus.js'
import { checkPositiveInteger } from '../../js/util/helper.js'

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },

    label: {
      type: String,
      default: '',
    },

    responseSelectionId: {
      type: String,
      default: '',
    },

    isCloud: {
      type: Boolean,
      default: false,
    },

    flex: {
      type: Boolean,
      default: true,
    },

    multiselect: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isFocused: false,
      selectedOptions: [],
    }
  },

  computed: {
    filtersCount() {
      return this.selectedOptions?.length || 0
    },
  },

  watch: {
    /**
     * When options are changed, emit the change
     * back to the parent to update component/store
     */
    selectedOptions: {
      handler: function () {
        if (this.responseSelectionId) {
          let emitValue = null

          if (this.multiselect) {
            emitValue = this.selectedOptions
          } else {
            const selectedOption = this.selectedOptions[0]
            if (checkPositiveInteger(selectedOption)) {
              emitValue = selectedOption
            }
          }

          EventBus.$emit(this.responseSelectionId, emitValue)
        }
      },

      deep: true,
    },
  },

  mounted() {
    EventBus.$on('resetInputDropdownExpanding', () => {
      this.$set(this, 'selectedOptions', [])
    })

    EventBus.$on('closeFilterDropdowns', () => {
      this.$set(this, 'isFocused', false)
    })

    // reset filters for event calendar
    this.dispatchSetFilterCloudBy({ reset: true })
  },

  methods: {
    ...mapActions({
      dispatchSetFilterCloudBy: 'careerwise/dispatchSetFilterCloudBy',
    }),

    toggleFocus() {
      this.$set(this, 'isFocused', !this.isFocused)
    },

    /**
     * Check if option is selected or not and update models
     * accordingly.
     *
     * If multiselect: add/remove option to/from selected
     * options array if it is not/is already selected.
     *
     * If single select: if already selected, do nothing;
     * else add to array.
     *
     * @param {object} option: triggered option
     */
    triggerSelected(option) {
      const index = this.selectedOptions.indexOf(option.value)

      if (index > -1) {
        // This option is currently selected; unselect it
        this.selectedOptions.splice(index, 1)
      } else {
        // This option is not currently selected
        if (this.multiselect) {
          // Select this option too
          this.selectedOptions.push(option.value)
        } else {
          // Remove existing option and select this one
          this.$set(this, 'selectedOptions', [])
          this.selectedOptions.push(option.value)
        }
      }
    },
  },
}
</script>
